export function CardReviews({ listing, cardReviews, onReviewClick }) {
  const review = cardReviews[0];
  return (
    <div className="px-5 pb-4">
      {review ? (
        <blockquote className="border-l-2 border-slate-300 pl-3">
          <p className="font-body text-xs text-gray-600 line-clamp-2">“{review.reviewText}”</p>
          <p className="font-body text-[10px] text-gray-500 mt-1">{review.reviewerName || "Community member"}</p>
        </blockquote>
      ) : (
        <button onClick={(event) => { event.stopPropagation(); onReviewClick?.(listing.name); }} className="font-body text-xs text-navy underline underline-offset-4" data-testid={`card-review-btn-${listing.id}`}>Share the first community review</button>
      )}
    </div>
  );
}